import { createContext } from 'react';

export const ShareSettingsScopedContext = createContext<string | null>(null);
